import React, { useState, SyntheticEvent } from "react";
import { Category as CategoryType, Authorization } from "types";
import { useSelector } from "react-redux";
import type { RootState } from "store";
import { createChange } from "create_change";

export const Category = (props: {
  category: CategoryType;
  authorization: Authorization;
}) => {
  const showMode = "showMode";
  const editNameMode = "editNameMode";
  const [mode, setMode] = useState(showMode);
  const [newName, setNewName] = useState("");
  const { isSuggestionMode } = useSelector(
    (state: RootState) => state.suggestion.value,
  );

  const canEditCategory = () => {
    return props.authorization.can_edit_category || isSuggestionMode;
  };

  const canDestroyCategory = () => {
    return props.authorization.can_destroy_category || isSuggestionMode;
  };

  const editLink = () => {
    if (canEditCategory()) {
      return (
        <a href="#" title="Edit category" onClick={enableEditNameMode}>
          <i className="bi-pencil-square"></i>
        </a>
      );
    }
  };

  const deleteCategoryRequest = (event: SyntheticEvent) => {
    event.preventDefault();
    createChange({
      name: "deleteCategory",
      payload: {
        categoryName: props.category.name,
      },
    });
  };

  const updateCategoryName = (event: SyntheticEvent) => {
    event.preventDefault();

    createChange({
      name: "renameCategory",
      payload: {
        oldCategoryName: props.category.name,
        newCategoryName: newName.trim(),
      },
    }).then(() => enableShowMode(event));
  };

  const destroyLink = () => {
    if (canDestroyCategory()) {
      return (
        <a
          onClick={deleteCategoryRequest}
          href="#"
          title="Delete category"
          style={{ fontSize: "1.5rem" }}
        >
          <i className="bi-trash"></i>
        </a>
      );
    }
  };

  const enableShowMode = (e: SyntheticEvent) => {
    e?.preventDefault();
    setMode(showMode);
  };

  const enableEditNameMode = (event: SyntheticEvent) => {
    event.preventDefault();

    setNewName(props.category.name);
    setMode(editNameMode);
  };

  if (mode === editNameMode) {
    return (
      <form onSubmit={updateCategoryName}>
        <div className="row mb-2 g-0" id={`category-${props.category.id}`}>
          <div className="col-auto">
            <input
              className="form-control"
              type="text"
              id="category-name"
              name="category-name"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
            />
          </div>
          <div className="col-auto">
            <a
              onClick={
                props.category.name === newName
                  ? enableShowMode
                  : updateCategoryName
              }
              title="Save"
              href="#"
            >
              <i
                className="bi-check text-success"
                style={{ fontSize: "1.5rem" }}
              ></i>
            </a>
            <a onClick={enableShowMode} title="Cancel editing" href="#">
              <i
                className="bi-x text-warning"
                style={{ fontSize: "1.5rem" }}
              ></i>
            </a>
            {destroyLink()}
          </div>
        </div>
      </form>
    );
  }

  return (
    <h4 className="text-break" id={`category-${props.category.id}`}>
      {props.category.name === "" ? "other" : props.category.name}
      {editLink()}
    </h4>
  );
};
